import * as React from "react";
import { IconProps } from "./IconProps";

export const IconWarning = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="CellStatus [ARCHIVED]">
          <path
            id="Union"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.71355 3.42845C7.27065 2.52996 8.58866 2.52237 9.15616 3.41476L14.026 11.0726C14.6224 12.0104 13.95 13.25 12.809 13.25H3.19102C2.05746 13.25 1.3836 12.0246 1.96541 11.0863L6.71355 3.42845ZM10.4219 2.60984C9.26117 0.784607 6.57862 0.799572 5.43872 2.63801L0.690581 10.2958C-0.521415 12.2505 0.901892 14.75 3.19102 14.75H12.809C15.113 14.75 16.5341 12.2212 15.2917 10.2676L10.4219 2.60984ZM8.92565 5.00516C8.96582 4.46245 8.53633 4 7.99213 4C7.45379 4 7.02639 4.45298 7.05764 4.99041L7.26516 8.55871C7.28668 8.92883 7.5931 9.21795 7.96385 9.21795C8.33034 9.21795 8.63476 8.93522 8.66182 8.56973L8.92565 5.00516ZM7.2897 11.7308C7.4828 11.9103 7.72188 12 8.00694 12C8.2828 12 8.51729 11.9103 8.71039 11.7308C8.90349 11.5513 9.00005 11.3291 9.00005 11.0641C9.00005 10.7991 8.90349 10.5769 8.71039 10.3974C8.51729 10.2179 8.2828 10.1282 8.00694 10.1282C7.72188 10.1282 7.4828 10.2179 7.2897 10.3974C7.0966 10.5769 7.00005 10.7991 7.00005 11.0641C7.00005 11.3291 7.0966 11.5513 7.2897 11.7308Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
